export enum UsersRole {
  SUPER_ADMIN = 1,
  BUILDING_ADMINISTRATOR = 999,
  MAINTANER = 1003,
  SYSTEM = 1000,
  RESIDENT = 1002,
}

/**
 * Values assumed by the "trial" flag returned by the login response
 */
export enum TrialFlag {
  ACTIVE = "S",
  NOT_ACTIVE = "N",
}

export enum EnergyCoefficient {
  A4 = 100,
  A3 = 90,
  A2 = 80,
  A1 = 70,
  B = 60,
  C = 50,
  D = 40,
  E = 30,
  F = 20,
  G = 10,
  UNKNOWN = 0,
}

export enum BACSCoefficient {
  A = 40,
  B = 30,
  C = 20,
  D = 10,
  UNKNOWN = 0,
}

export enum TypeUploadFile {
  BILL = 1,
  QUOTE = 2,
  DOCUMENT = 3,
  UNKNOWN = 0,
}

export enum LevelProtection {
  ADMINISTRATOR = 18,
  MAINTENANCE = 19,
  SYSTEM = 20,
  RESIDENT = 21,
  SUPERADMIN = 22,
}

/**
 * External management-software integrations that can be enabled on a condominium.
 * The value is the "typeIntegration" parameter expected by the API.
 */
export enum TypeIntegration {
  CED_HOUSE = 1,
  ICOND = 2,
}
